import { CoinIcon, type InventoryItemData } from '@repo/ui'
import { freeBetGroupCardCopy } from '../utils/freeBetGroupCardCopy'
import type { FreeBetGroup } from '../utils/groupFreeBets'

/**
 * One sidebar card per free-bet group, e.g. "10× Free play · $5". Read-only —
 * free bets apply automatically, so there is no footer/CTA (unlike boosters).
 */
export const mapFreeBetGroupToItemData = (
  group: FreeBetGroup,
  t: (key: string, params?: Record<string, unknown>) => string,
  gameName?: string
): InventoryItemData => {
  const copy = freeBetGroupCardCopy(group, t, gameName)

  return {
    id: group.key,
    name: copy.name,
    quantity: copy.value,
    icon: <CoinIcon className="w-[14px] h-[14px] drop-shadow-[0_0_2px_rgba(0,0,0,0.25)]" />,
    accentColor: 'green',
    description: copy.description,
    subtitle: t('Free bet')
  }
}
